import React from 'react'

// The icon props (`selectedIcon`, `otherIcon`, `matchIcon`) are lucide
// components.
const CELL_CLASSES = 'h-1 w-[50px] select-none border border-border p-0 text-center'

const renderIcon = (Icon) => {
  return Icon ? <Icon className="inline size-3.5 text-white"/> : null
}

class AvailabilityTimeslot extends React.Component {

  render() {
    if (this.props.selected && this.props.matching)
      return (
        <td className={`${CELL_CLASSES} bg-[#3ecf8e]`}>
          {renderIcon(this.props.matchIcon)}
        </td>
      )
    else if (this.props.selected)
      return (
        <td className={`${CELL_CLASSES} bg-[#68d4f8]`}>
          {renderIcon(this.props.selectedIcon)}
        </td>
      )
    else if (this.props.matching)
      return (
        <td className={`${CELL_CLASSES} bg-[#7795f8]`}>
          {renderIcon(this.props.otherIcon)}
        </td>
      )
    else
      return (
        <td className={CELL_CLASSES}>
        </td>
      )
  }
}

export default AvailabilityTimeslot
